var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPointCoupon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#point-coupon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1C9CFF",
  d: "M4.35 3a2.7 2.7 0 0 0-2.7 2.7v2.846c1.298.523 2.212 1.771 2.212 3.229 0 1.457-.914 2.705-2.212 3.228v2.846a2.7 2.7 0 0 0 2.7 2.7h4.757V3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B6E3FE",
  d: "M21.902 8.546V5.7a2.7 2.7 0 0 0-2.7-2.7H9.109v17.55h10.093a2.7 2.7 0 0 0 2.7-2.7v-2.847c-1.299-.523-2.213-1.771-2.213-3.229 0-1.457.914-2.705 2.213-3.229"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#point-coupon_svg__b)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#point-coupon_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFE560",
  d: "M17.5 23.35a5.85 5.85 0 1 0 0-11.7 5.85 5.85 0 0 0 0 11.7"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D6B100",
  d: "m19.267 15.092-1.016 4.624h-1.434l-.34-1.99-.437 1.99h-1.349l-.849-3.288 1.395-.344.274 1.97.39-2.133 1.14-.28.418 2.444.264-2.612zM21.026 15.896l-.68 2.675h-1.082l.412-3.406zm-.769 3.618c0 .357-.275.647-.614.647s-.614-.29-.614-.647.275-.647.614-.647.614.29.614.647"
}))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "point-coupon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "point-coupon_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 14.791A3.79 3.79 0 0 1 14.793 11h5.417A3.79 3.79 0 0 1 24 14.792v5.417A3.79 3.79 0 0 1 20.21 24h-5.417a3.79 3.79 0 0 1-3.791-3.792z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "point-coupon_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11 11h13v13H11z"
})))));
export default SvgPointCoupon;